import { $, $$ } from '../helpers/selectors';
import breakpoints from '../helpers/breakpoints';
import createFocusTrap from 'NM/focus-trap/dist/focus-trap';

const SELECTOR = '.menu';
class Navigation {
  constructor() {
    if (! $('.main-navigation__container-wrap')) {
      return false;
    }

    const body = document.body;
    const previewBar = $('.wt-preview-bar');
    const menuNew = $('.main-navigation__container-wrap');
    const previewBarExit = $('.wt-preview-bar__exit');

    const desktopBreakpoint = breakpoints.desktop;

    let lastScroll = 0;
    let scrollDelay = null;

    function handleOnScroll() {
      const currentScrollPos = window.pageYOffset;

      if (body.classList.contains('is-preview-bar-visible')) {
        const scrollOffset = $('.admin-bar') ? 78 : 46;
        if (currentScrollPos >= scrollOffset) {
          body.classList.add('is-preview-bar-visible--menu-is-sticky');
        } else {
          body.classList.remove('is-preview-bar-visible--menu-is-sticky');
        }
      }

      if (currentScrollPos > 0) {
        menuNew.classList.add('is-hidden');
        menuNew.classList.add('menu-is-floating');
      } else {
        menuNew.classList.remove('is-hidden');
        menuNew.classList.remove('menu-is-floating');
      }

      if (currentScrollPos < lastScroll) {
        if (menuNew.classList.contains('is-hidden')) {
          menuNew.classList.remove('is-hidden');
        }
        if (scrollDelay) {
          clearTimeout(scrollDelay); //cancel the previous timer.
          scrollDelay = null;
        }
        scrollDelay = setTimeout(() => {
          if (window.pageYOffset !== 0) {
            menuNew.classList.add('is-hidden');
          }
        }, 4000);
      }

      lastScroll = currentScrollPos;
    }

    function handleLogoutModal() {
      const logoutBtns = $$('.js-logout-modal');
      const logoutModal = $('.logout-modal');

      if (logoutBtns.length !== 0 && logoutModal) {
        let currentFocus = null;
        const logoutModalClose = $$('.js-logout-modal-close');
        const elementsToBeHidden = $$('.main, .menu, .footer, .err404, .site-main, .support-area, .article, .intro-area, .content-area, .reachout');
        const logoutModalTexts = $('.logout-modal__content-text');
        let isScrollDisabled = false;
        let lastRecordedScroll = 0;
        // Disable the scrolling
        const disableScroll = () => {
          if (! isScrollDisabled && typeof document !== 'undefined' && document.body) {
            const bounds = document.body.getBoundingClientRect();
            isScrollDisabled = true;
            // save the current scroll position
            lastRecordedScroll = -(bounds.top) || 0;

            // set the styling of body to a fixed position
            // and its top position to the `this.lastRecordedScroll` value
            document.body.style.position = 'fixed';
            document.body.style.top = `-${ lastRecordedScroll }px`;
            document.body.style.width = '100vw';
            document.body.style.overflow = 'hidden';
          }
        };
        // Enable the scrolling
        // Reset the styling set by the `disableScroll()` function
        const enableScroll = () => {
          if (typeof document !== 'undefined' && document.body && typeof window !== 'undefined') {
            const additionalOffset = previewBar ? 46 : 0;
            if (isScrollDisabled) {
              isScrollDisabled = false;
              const lastBodyScroll = $('.admin-bar') ? ((lastRecordedScroll + 46) + additionalOffset) : lastRecordedScroll + additionalOffset;
              // reset the styling of the body
              document.body.style.position = '';
              document.body.style.top = '';
              document.body.style.width = '';
              document.body.style.overflow = '';
              // scroll to the saved position
              window.scrollTo(0, lastBodyScroll);
            }
          }
        };

        logoutBtns.forEach(logoutBtn => {
          logoutBtn.addEventListener('click', e => {
            e.preventDefault();
            currentFocus = e.currentTarget;
            logoutModal.classList.add('is-visible');
            logoutModal.removeAttribute('aria-hidden');
            body.classList.add('overflow-hidden');
            logoutFocus.activate();
            elementsToBeHidden.forEach(item => {
              item.setAttribute('aria-hidden', 'true');
            });
            logoutModalTexts.focus();
            disableScroll();
          });
        });

        logoutModalClose.forEach(item => {
          item.addEventListener('click', e => {
            e.preventDefault();
            logoutModal.classList.remove('is-visible');
            logoutModal.setAttribute('aria-hidden', 'true');
            body.classList.remove('overflow-hidden');
            logoutFocus.deactivate();
            elementsToBeHidden.forEach(elem => {
              elem.removeAttribute('aria-hidden');
            });

            currentFocus.focus();
            enableScroll();
          });
        });
      }
    }

    function handlePreviewBar() {
      if (previewBar) {
        body.classList.add('is-preview-bar-visible');
        previewBarExit.addEventListener('click', () => {
          $('.wt-preview-bar').classList.add('is-hidden');
          body.classList.remove('is-preview-bar-visible');
        });
      }
    }

    //Bind and initialize scripts
    window.addEventListener('scroll', handleOnScroll);
    handleOnScroll();
    handleLogoutModal();
    handlePreviewBar();
  }
}

export default Navigation;
